import { ACCRUAL_TYPE_ENUM } from '../enums/accrual-type.enum';
import { COUPON_TYPE } from '../enums/coupon-type.enum';
import { SCHEDULE_TYPE_ENUM } from '../enums/schedule-type.enum';
import { DropDownOption } from '../interfaces/drop-down-option.interface';

export const ACCRUAL_PERIOD_TYPES = [
  { id: ACCRUAL_TYPE_ENUM.NONE.toString(), displayValue: 'None' },
  {
    id: ACCRUAL_TYPE_ENUM.PAYMENT_ADJUSTED.toString(),
    displayValue: 'Payment Adjusted',
  },
  {
    id: ACCRUAL_TYPE_ENUM.PAYMENT_UNADJUSTED.toString(),
    displayValue: 'Payment Unadjusted',
  },
  {
    id: ACCRUAL_TYPE_ENUM.OBS_UNADJUSTED.toString(),
    displayValue: 'Observation Unadjusted',
  },
  { id: ACCRUAL_TYPE_ENUM.ADJUSTED.toString(), displayValue: 'Adjusted' },
  { id: ACCRUAL_TYPE_ENUM.UNADJUSTED.toString(), displayValue: 'Unadjusted' },
  {
    id: ACCRUAL_TYPE_ENUM.OBS_ADJUSTED.toString(),
    displayValue: 'Observation Adjusted',
  },
];

export const DEFAULT_ACCRUAL_PERIOD_TYPE = ACCRUAL_PERIOD_TYPES[2].id;

export const ACCRUAL_PERIOD_TYPES_CLN = [
  { id: ACCRUAL_TYPE_ENUM.ADJUSTED.toString(), displayValue: 'Adjusted' },
  { id: ACCRUAL_TYPE_ENUM.UNADJUSTED.toString(), displayValue: 'Unadjusted' },
];

export const AccrualPeriodTypesLabels = {
  [ACCRUAL_TYPE_ENUM.PAYMENT_ADJUSTED]: 'Adjusted Payment Dates',
  [ACCRUAL_TYPE_ENUM.PAYMENT_UNADJUSTED]: 'Unadjusted Payment Dates',
  [ACCRUAL_TYPE_ENUM.ADJUSTED]: 'Adjusted',
  [ACCRUAL_TYPE_ENUM.UNADJUSTED]: 'Unadjusted',
  [ACCRUAL_TYPE_ENUM.OBS_ADJUSTED]: 'Adjusted Obs. Dates',
  [ACCRUAL_TYPE_ENUM.OBS_UNADJUSTED]: 'Unadjusted Obs. Dates',
}

export function getAccrualPeriodTypes(couponType: COUPON_TYPE, scheduleType: SCHEDULE_TYPE_ENUM): DropDownOption[] {
  const accrualPeriodTypes = {
    [SCHEDULE_TYPE_ENUM.OBS_PRIMARY]: buildAccrualPeriodTypesOptions(
      ACCRUAL_TYPE_ENUM.OBS_UNADJUSTED,
      ACCRUAL_TYPE_ENUM.OBS_ADJUSTED,
      ACCRUAL_TYPE_ENUM.PAYMENT_ADJUSTED
    ),
    [SCHEDULE_TYPE_ENUM.PAYMENT_PRIMARY]: buildAccrualPeriodTypesOptions(
      ACCRUAL_TYPE_ENUM.PAYMENT_UNADJUSTED,
      ACCRUAL_TYPE_ENUM.PAYMENT_ADJUSTED,
      ACCRUAL_TYPE_ENUM.OBS_ADJUSTED
    ),
    [SCHEDULE_TYPE_ENUM.INDEPENDENT]: buildAccrualPeriodTypesOptions(
      ACCRUAL_TYPE_ENUM.PAYMENT_UNADJUSTED,
      ACCRUAL_TYPE_ENUM.PAYMENT_ADJUSTED,
      ACCRUAL_TYPE_ENUM.OBS_UNADJUSTED,
      ACCRUAL_TYPE_ENUM.OBS_ADJUSTED,
    ),
    [SCHEDULE_TYPE_ENUM.PAYMENT_ONLY]: buildAccrualPeriodTypesOptions(
      ACCRUAL_TYPE_ENUM.PAYMENT_UNADJUSTED,
      ACCRUAL_TYPE_ENUM.PAYMENT_ADJUSTED,
    ),
    [SCHEDULE_TYPE_ENUM.ACCRUAL_PRIMARY]: buildAccrualPeriodTypesOptions(
      ACCRUAL_TYPE_ENUM.UNADJUSTED,
      ACCRUAL_TYPE_ENUM.ADJUSTED,
    )
  }

  if ([COUPON_TYPE.FIXED, COUPON_TYPE.FLOATING, COUPON_TYPE.FIXED_TO_FLOATING].includes(couponType)) {
    accrualPeriodTypes[SCHEDULE_TYPE_ENUM.PAYMENT_PRIMARY] = buildAccrualPeriodTypesOptions(
      ACCRUAL_TYPE_ENUM.PAYMENT_UNADJUSTED,
      ACCRUAL_TYPE_ENUM.PAYMENT_ADJUSTED,
    );

    accrualPeriodTypes[SCHEDULE_TYPE_ENUM.INDEPENDENT] = buildAccrualPeriodTypesOptions(
      ACCRUAL_TYPE_ENUM.PAYMENT_UNADJUSTED,
      ACCRUAL_TYPE_ENUM.PAYMENT_ADJUSTED,
    );
  }

  return accrualPeriodTypes[scheduleType];
};

export const DEFAULT_ACCRUAL_PERIOD_TYPES_BY_SCHEDULE_TYPE = {
  [SCHEDULE_TYPE_ENUM.OBS_PRIMARY]: ACCRUAL_TYPE_ENUM.OBS_UNADJUSTED.toString(),
  [SCHEDULE_TYPE_ENUM.PAYMENT_PRIMARY]:
    ACCRUAL_TYPE_ENUM.PAYMENT_UNADJUSTED.toString(),
  [SCHEDULE_TYPE_ENUM.INDEPENDENT]:
    ACCRUAL_TYPE_ENUM.PAYMENT_UNADJUSTED.toString(),
  [SCHEDULE_TYPE_ENUM.PAYMENT_ONLY]:
    ACCRUAL_TYPE_ENUM.PAYMENT_UNADJUSTED.toString(),
  [SCHEDULE_TYPE_ENUM.OBS_ONLY]: ACCRUAL_TYPE_ENUM.OBS_UNADJUSTED.toString(),
  [SCHEDULE_TYPE_ENUM.ACCRUAL_PRIMARY]: ACCRUAL_TYPE_ENUM.UNADJUSTED.toString(),
};

function buildAccrualPeriodTypesOptions(...options: ACCRUAL_TYPE_ENUM[]): DropDownOption[] {
  return options.map((option) => ({
    id: option.toString(),
    displayValue: AccrualPeriodTypesLabels[option],
  }));
}